import { useQuery } from 'react-query';
import { client } from '../index';

type FetchAccessSessionResponse = {
    errorCode: string;
    errorMessage: string;
    isAllowed: boolean;
};

const fetchAccessSession = async (eventId: string, sessionId: string) => {
    const response = await client().get(
        `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/accessAllowance`
    );

    return response.data as FetchAccessSessionResponse;
};

type UseAccessSessionProps = (
    eventId: string,
    sessionId: string
) => {
    error: Error;
    isLoading: boolean;
    data: {
        errorCode: string;
        errorMessage: string;
        isAllowed: boolean;
    };
};

const useAccessSession: UseAccessSessionProps = (eventId, sessionId) => {
    return useQuery<FetchAccessSessionResponse, Error>(
        ['accessSession', eventId, sessionId],
        () => fetchAccessSession(eventId, sessionId),
        {
            retry: 0,
        }
    );
};

export default useAccessSession;
